(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-tab"]) return;
  try {
    
  $(document).ready(function() {
  $('ul.tabs').each(function(){
  var active, content, links = $(this).find('a');
  active = links.first().addClass('active');
  content = $(active.attr('href'));
  links.not(':first').each(function () {
  $($(this).attr('href')).hide();
  });

  $(this).find('a').click(function(e){
  active.removeClass('active');
  content.hide();
  active = $(this);
  content = $($(this).attr('href'));
  active.addClass('active');
  content.show();
  return false;
  });
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psd-faq"]) return;
  try {
    
  $(document).ready(function() {
  $('ul.tabs1').each(function(){
  var active, content, links = $(this).find('a');
  active = links.first().addClass('active');
  content = $(active.attr('href'));
  links.not(':first').each(function () {
  $($(this).attr('href')).hide();
  });

  $(this).find('a').click(function(e){
  active.removeClass('active');
  content.hide();
  active = $(this);
  content = $($(this).attr('href'));
  active.addClass('active');
  content.show();
  return false;
  });
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selector-tool"] && !Shopify.designMode) return;
  try {
    
  /* MODAL FUNCTIONALITY */
  /* on button click, show the modal */
 $(document).on('click', '.use-selector-tool', function () {
    OpenSelector();
  });
  /* on click outside of the modal, hide it */
  $(document).on('click', '.st-container', function () {
    CloseSelector();
  });
  /* on close click, hide modal */
  $(document).on('click', '.st-close', function () {
    CloseSelector();
  });

  function OpenSelector(){
    console.log("OpenSelector");
     if($("#iframe-content-div").css("display") == "none"){
      $("#calculator-iframe").attr("src", "https://app.pumpstationsdirect.com.au/index.html?customerID={{ customer.id }}");
      $('.st-container').css('display', 'flex');
      SetScrollCapture();
    }
    else{
      console.log("Already Open");
    }
  }

  function CloseSelector(){
    console.log("CloseSelector");
    if($("#iframe-content-div").css("display") != "none"){
       $('.st-container').css('display', 'none');
       $("#calculator-iframe").attr("src", "");
      ReleaseScrollCapture();
    }
    else{
     console.log("Already Closed");
    }
  }

  function SetScrollCapture(){
    console.log("selector-tool-footer: SetScrollCapture()");
    const scrollY = window.top.scrollY;
    console.log("ScrollY: " + scrollY);
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollY + "px";
    document.body.style.width = '100%';
  }

  function ReleaseScrollCapture(){
    console.log("selector-tool-footer: ReleaseScrollCapture()");
    const scrollY = document.body.style.top;
    console.log("ScrollY: " + scrollY);
    document.body.style.position = 'relative';
    document.body.style.top = '';
    //window.scrollTo(0, parseInt(scrollY || '0') * -1);
    window.scrollTo(0, parseInt(scrollY) * -1);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technical-data-new"]) return;
  try {
    
  $(document).ready(function() {
  $('ul.tabs').each(function(){
  var active, content, links = $(this).find('a');
  active = links.first().addClass('active');
  content = $(active.attr('href'));
  links.not(':first').each(function () {
  $($(this).attr('href')).hide();
  });

  $(this).find('a').click(function(e){
  active.removeClass('active');
  content.hide();
  active = $(this);
  content = $($(this).attr('href'));
  active.addClass('active');
  content.show();
  return false;
  });
  });
  });

  } catch(e) { console.error(e); }
})();
})();
